
import { DandDCharacterUtilitiesClass } from "@dndUtilities/char_utilities_class";

const DandDCharacterUtilities = (function () {
  let instance: DandDCharacterUtilitiesClass;

  function createInstance() {
    const util = new DandDCharacterUtilitiesClass();
    return util;
  }

  return {
    getInstance: function () {
      if (!instance) {
        instance = createInstance();
      }
      return instance;
    }
  };
})();

export default DandDCharacterUtilities;
